module.exports = __webpack_public_path__ + "img/6-0-3.8e7a21e8.png";